var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./libs/element-ui/~/core-js/library/modules/_html.js
// module id = 201
// module chunks = 0